module.exports = __webpack_public_path__ + "img/kljukica_zelena.e17e64cb.svg";